// Countdown function to remove error toast message after 10sec
const setErrorCountdown = id => {
  setTimeout(() => document.getElementById(id).remove(), 10000);
}

export const ThrowError = (element, response) => {
  const el = document.getElementById(element.id);
  let elErrList = document.getElementById('onsched-errors-list');
  
  // Create error list element if it does not exist
  if (!elErrList) {
    elErrList = document.createElement('DIV');
    elErrList.id = 'onsched-errors-list';
    elErrList.className = 'onsched-errors-list';

    // Prepend error list to top of OnSched Element
    el.prepend(elErrList);
  }

  // Create error toast message for each error in response
  response.data.errors.map(error => {
    const elError = document.createElement('DIV');
    elError.className = 'onsched-error-toast';
    elError.id = new Date().getTime();

    // Create error toast message template
    elError.innerHTML = `<h5>${error.status}</h5><span>${error.error}</span><i class="fal fa-times"></i>`;
  
    // Add error toast message to errors list element
    elErrList.appendChild(elError);
    setErrorCountdown(elError.id);

    // Remove error toast message on close
    document.getElementById(elError.id).childNodes[2].onclick = () => elError.remove();
  })
}

export const ReformatErrorMsg = (response, errorCode, message) => {
  let data = response;
  
  // Check if expected error code exists in response errors
  if (response.data.errors.filter(e => e.code === errorCode).length) {
    // replace the error message
    let error = response.data.errors.filter(e => e.code === errorCode)[0];
    error.error = message;
    
    // Recreate response structure with new error to pass to ThrowError helper
    data = {
      code: response.code,
      data: { errors: [ error ] },
      error: response.errror,
      validation: response.validation
    }
  }

  return data;
}
